import router from "@/router"
import * as JsCookie from "js-cookie"

const Cookies = JsCookie.default
// const IMAGE_URL = process.env.VUE_APP_IMAGE_URL

const parseJSON = (value, fallback = null) => {
  if (!value) return fallback

  try {
    return JSON.parse(value)
  } catch (error) {
    return fallback
  }
}

export const setCookie = (cookie) => {
  Cookies.set("simpan-biz-token", `Bearer ${cookie}`, { path: "/" })
  return {
    token: Cookies.get("simpan-biz-token")
  }
}

export const setCookieProfile = (data) => {
  const stringProfile = JSON.stringify({
    name: data.name,
    email: data.email,
    role: data.role,
    status: data.status,
    is_first_time_login:
      data?.role?.name?.toUpperCase() != "SUPER ADMIN"
        ? data.is_first_time_login
        : false,
    authorized_level:
      data?.role?.name?.toUpperCase() != "SUPER ADMIN"
        ? data?.authorized_level?.join(",")
        : "",
    working_position:
      data?.role?.name?.toUpperCase() != "SUPER ADMIN"
        ? data?.authorized_level
        : [],
    user_employee:
      data?.role?.name?.toUpperCase() != "SUPER ADMIN"
        ? data?.user_employee
        : {},
    user_id: data?.id,
    photo: ""
  })
  Cookies.set("simpan-biz-user", stringProfile, { path: "/" })
}

export const setUserEmployee = (data) => {
  const totalSubdivision = data?.company?.total_subdivision || 0
  const subdivision = data?.company?.subdivision === true || totalSubdivision > 1
  const user_employee = JSON.stringify({
    employee_id: data?.employee_id || "",
    id: data?.company?.id,
    generate_invoice: data?.company?.generate_invoice,
    subdivision,
    total_subdivision: totalSubdivision
  })
  Cookies.set("simpan-biz-user-employee", user_employee)
}

export const getUserEmployee = () => {
  const val = Cookies.get("simpan-biz-user-employee")
  return parseJSON(val, null)
}

export const getUserProfile = () => {
  return parseJSON(Cookies.get("simpan-biz-user"), null)
}

export const setUpdateProfile = (data) => {
  const stringProfile = JSON.stringify({
    name: data.name,
    role: data.role,
    email: data.email,
    photo: data.photo
  })
  Cookies.set("simpan-biz-user", stringProfile, { path: "/" })
}

export const setStorageRole = (data) => {
  if (!Array.isArray(data)) {
    throw new TypeError("role management data must be an array")
  }
  localStorage.setItem("role_managements", JSON.stringify(data))
}

export const getUserRole = () => {
  const stored = localStorage.getItem("role_managements")
  return parseJSON(stored, null) === null ? "[]" : stored
}

export const setStorageRoleInfo = (role_management, role) => {
  if (role.Name == "Super Admin") {
    role_management = []
  }
  const obj = {
    role_management: role_management,
    role: role
  }
  localStorage.setItem("simpan-biz-role-info", JSON.stringify(obj))
  return localStorage.getItem("simpan-biz-role-info")
}

export const getUserToken = () => {
  return Cookies.get("simpan-biz-token")
}

export const getUserRoleInfo = () => {
  return localStorage.getItem("simpan-biz-role-info")
}

export const isLogin = () => {
  const token = Cookies.get("simpan-biz-token")
  const userCookie = Cookies.get("simpan-biz-user")
  const userRole = parseJSON(localStorage.getItem("role_managements"), null)

  if (token && userCookie && userRole) {
    return true
  }
  return false
}

export const isCanAccess = (type, menu) => {
  const userAccesses = parseJSON(localStorage.getItem("simpan-biz-role-info"), null)
  let result = false
  if (!userAccesses?.role) return result
  if (userAccesses.role.Name === `Super Admin`) {
    result = true
  } else {
    const findAccess = userAccesses.role_management.find(
      (x) => x.name === menu
    )
    result = findAccess ? findAccess[type] : false
  }
  return result
}

export const checkRoleAccess = (type, menu) => {
  const userRole = parseJSON(localStorage.getItem("role_managements"), null)

  let result = false
  if (!userRole) return result
  const findAccess = userRole.find(
    (x) => x.menu?.toUpperCase() === menu?.toUpperCase()
  )
  if (findAccess) {
    result = findAccess[type]
  }
  return result
}

// preserveRedirect=true: used for session-expiry (401) so the router guard can capture
// the current fullPath and resume the SAME user there after re-login.
// preserveRedirect=false (default, explicit logout): navigate straight to a clean
// /login with no redirect query, so the next login (any account) lands on Dashboard.
export const logoutUser = (preserveRedirect = false) => {
  Cookies.remove("simpan-biz-token", { path: "/" })
  Cookies.remove("simpan-biz-id", { path: "/" })
  Cookies.remove("simpan-biz-user", { path: "/" })
  Cookies.remove("simpan-biz-user-employee", { path: "/" })

  localStorage.clear()
  if (preserveRedirect) {
    router.go(0)
  } else {
    router.push('/login')
  }
}
